import React from 'react'
import Box from "@mui/material/Box";
import { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import BreadCrumb from "app/components/BreadCrumb";
import { ScrollableView } from "app/components/ScrollableView";
import { useTranslation } from "react-i18next";
import { useInjectReducer } from "redux-injectors";
import { useInjectSaga } from 'redux-injectors';
import { ActionBar } from "./components/ActionBar";
import { reducer, sliceKey, actions } from './redux/slice';
import { useUserManagementSaga } from './redux/saga'
import { useStyles } from "./styles";
import AdminManagementTable from "./components/AdminMangementTable/index"
import {
  selectIsLoading,
  selectFilteredData,
  selectAdminManagementMeta,
} from "./redux/selector";
import { adminManagementTableRow } from './types';
import AddUserModal from './components/AddUserModal'


const AdminManagement = () => {
const styles = useStyles();
const { t, i18n } = useTranslation();
const loading: boolean = useSelector(selectIsLoading)
const rows: adminManagementTableRow[] = useSelector(selectFilteredData)
const meta = useSelector(selectAdminManagementMeta)
const dispatch = useDispatch()


useInjectReducer({
  key: sliceKey,
  reducer,
});

useInjectSaga({
  key: sliceKey,
  saga: useUserManagementSaga
})

useEffect(() => {
     dispatch(actions.getUserList())
  }, [dispatch]);

  const hasMoreItems = meta.currentPage < meta.totalPages;

  const getNextPage = () => {
    if (!loading && hasMoreItems) {
      dispatch(actions.getNextPageItems());
    }
  };

  return (<Box className={styles.container}>
        <Box className={styles.scrollContent} dir={i18n.dir()}>
          <Box className={styles.pageContent}>
            <BreadCrumb title={t("SIDEBAR.USER_MANAGEMENT")} iconPosition="end" />
            <ActionBar onAddClick={() => dispatch(actions.openAddModal())} />
            <Box className={styles.tableContainer}>
            <ScrollableView
              borderless
              height="calc(100vh - 200px)"
              loadMore={getNextPage}
              hasMoreItems={hasMoreItems}
            >
              <AdminManagementTable rows={rows} loading={loading && rows.length === 0} />
            </ScrollableView>
            </Box>
          </Box>
        </Box>
        <AddUserModal />
    </Box>
  )
}

export default AdminManagement
